<template>
  <div class="delivery-fee">
    <v-layout justify-space-between class="color--orange total-row">
      <v-flex class="d-flex align-center">
        배달 수수료 분석
      </v-flex>
    </v-layout>

    <div v-for="platform in filteredPlatforms" :key="platform.name" class="fee-bar-container">
      <div class="platform-info">
        <span class="platform-name">{{ platform.label }}</span>
        <span class="comparison-message" :class="{ 'high-fee': platform.current > platform.average }">
          - 다른 상점들의 평균 수수료보다 {{ platform.current > platform.average ? '높아요' : '낮아요' }}
        </span>
      </div>
      <div class="bars-container">
        <!-- 현재 수수료율 바 -->
        <div class="bar-group">
          <div class="bar-label">현재</div>
          <div class="bar current-bar">
            <div 
              class="bar-fill" 
              :style="{ 
                width: `${getPercentageWidth(platform.current)}%`, 
                backgroundColor: platform.current > platform.average ? '#ff4444' : '#4CAF50'
              }"
            ></div>
          </div>
          <div class="bar-value">{{ platform.current.toFixed(1) }}%</div>
        </div>
        <!-- 평균 수수료율 바 -->
        <div class="bar-group">
          <div class="bar-label">평균</div>
          <div class="bar average-bar">
            <div 
              class="bar-fill" 
              :style="{ 
                width: `${getPercentageWidth(platform.average)}%`,
                backgroundColor: '#999999'
              }"
            ></div>
          </div>
          <div class="bar-value">{{ platform.average.toFixed(1) }}%</div>
        </div>
      </div>
    </div>
    <p class="notice">수수료는 여신금융협회, 배달플랫폼의 정보를 기반으로 산출하였으나 실제와 다를 수 있습니다.</p>
  </div>
</template>

<script>
export default {
  name: 'DeliveryFeeComparison',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      platforms: [
        {
          name: 'baemin',
          label: '배민',
          average: 18.2,
          color: '#48dbab',
          current: 0
        },
        {
          name: 'yogiyo',
          label: '요기요',
          average: 20.9,
          color: '#f93c3c',
          current: 0
        },
        {
          name: 'coupang',
          label: '쿠팡이츠',
          average: 32.7,
          color: '#0073e9',
          current: 0
        }
      ]
    }
  },
  created() {
    // FeeTotal.vue 방식으로 데이터 처리
    console.log('******* ', this.data.paymentsDetail)

    if (this.data?.paymentsDetail) {
      this.platforms = this.platforms.map(platform => {
        for (const payment of this.data.paymentsDetail) {
            for (const amountDetail of payment.amountDetails) {
              console.log('***************', amountDetail)
              if (amountDetail.title === '수수료') {
                const feeData = amountDetail.data.find(d => d.name === platform.label)
                console.log('***************', feeData)
                if (feeData) {
                  return {
                    ...platform,
                    current: parseFloat(feeData.percentage)
                  }
                }
              }
          }
        }
        return platform
      })
    }

    console.log('Platforms data:', {
      rawData: this.data,
      processedPlatforms: this.platforms
    })
  },
  computed: {
    filteredPlatforms() {
      return this.platforms.filter(platform => platform.current > 0)
    },
    // 최대 수수료율 계산
    maxFeePercentage() {
      let max = 0
      this.filteredPlatforms.forEach(platform => {
        max = Math.max(max, platform.current, platform.average)
      })
      // 여유 공간을 위해 10% 추가
      return Math.ceil(max * 1.1)
    }
  },
  methods: {
    // 상대적인 너비 계산
    getPercentageWidth(value) {
      return (value / this.maxFeePercentage) * 100
    }
  }
}
</script>

<style lang="scss" scoped>
.delivery-fee {
  .total-row {
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 600;
  }

  .fee-bar-container {
    margin-bottom: 30px;
    
    .platform-info {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      
      .platform-name {
        font-weight: 500;
        font-size: 16px;
        margin-right: 8px;
      }
      
      .comparison-message {
        font-size: 14px;
        color: #4CAF50;
        
        &.high-fee {
          color: #ff4444;
        }
      }
    }

    .bars-container {
      .bar-group {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        .bar-label {
          width: 40px;
          font-size: 13px;
          color: #666;
        }

        .bar {
          flex: 1;
          height: 24px;
          background-color: #f0f0f0;
          border-radius: 4px;
          overflow: hidden;
          margin: 0 10px;  // 양쪽에 여백 추가

          .bar-fill {
            height: 100%;
            transition: width 0.3s ease;
          }
        }

        .bar-value {
          width: 50px;  // 값 표시 영역 고정 너비
          font-size: 13px;
          color: #666;
          text-align: right;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  img.icon {
    width: 22px;
    margin-right: 8px;
  }
}
</style> 